import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { useStore } from "vuex";
  import { toastError } from "@/helpers/toastError";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EoiDeclineRefundModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    eoiId: {
      type: String,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const props = __props;

  const form = reactive({
    comment: "",
  });

  function close() {
    form.comment = "";
    emits("close");
  }

  const disabled = ref(false);

  function save() {
    disabled.value = true;
    store
      .dispatch("eoi/eoiRefundDecline", {
        id: props.eoiId,
        data: {
          reason: form.comment,
        },
      })
      .then(() => {
        emits("confirm");
      })
      .catch((error) => {
        toastError(error);
      })
      .finally(() => {
        disabled.value = false;
      });
  }

const __returned__ = { store, emits, props, form, close, disabled, save, reactive, ref, Modal, get useStore() { return useStore }, get toastError() { return toastError } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})